import angular from 'angular';

angular
  .module('resumption', [])

  .config([
    '$stateProvider',
    function($stateProvider) {
      $stateProvider.state('resumption', {
        data: {
          authorizedRole: 'USER_BO'
        }
      });
    }
  ]);
